import { render, staticRenderFns } from "./RestoreEmail.vue?vue&type=template&id=ff113832"
import script from "./RestoreEmail.vue?vue&type=script&lang=js"
export * from "./RestoreEmail.vue?vue&type=script&lang=js"
import style0 from "./RestoreEmail.vue?vue&type=style&index=0&id=ff113832&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports